import { render } from "./FolderRow.vue?vue&type=template&id=6fe19f7b&scoped=true"
import script from "./FolderRow.vue?vue&type=script&lang=js"
export * from "./FolderRow.vue?vue&type=script&lang=js"

import "./FolderRow.vue?vue&type=style&index=0&id=6fe19f7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe19f7b"]])

export default __exports__